/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Builder_Triggers_PausedInputs */



/**
* | output |
* | --- |
* | "Schedules paused: {count}. They belong to other people, who can switch them back on." |
*
* @param {Agent_Builder_Triggers_PausedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_triggers_paused = /** @type {((inputs: Agent_Builder_Triggers_PausedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Triggers_PausedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Pausierte Zeitpläne: ${i?.count}. Sie gehören anderen Personen, die sie wieder einschalten können.`)
	return /** @type {LocalizedString} */ (`Schedules paused: ${i?.count}. They belong to other people, who can switch them back on.`)
});